import React, { useEffect, useMemo } from "react";
import Map from "@arcgis/core/Map";
import SceneView from "@arcgis/core/views/SceneView";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import Polygon from "@arcgis/core/geometry/Polygon";
import PolygonSymbol3D from "@arcgis/core/symbols/PolygonSymbol3D";
import ExtrudeSymbol3DLayer from "@arcgis/core/symbols/ExtrudeSymbol3DLayer";
import ObjectSymbol3DLayer from "@arcgis/core/symbols/ObjectSymbol3DLayer";
import FillSymbol3DLayer from "@arcgis/core/symbols/FillSymbol3DLayer";
import axios from "../axios";
import { isValidCoord } from "../utils/coordinateUtils";
import { format } from "date-fns";
const MapView = ({
  view,
  setView,
  polygons,
  polygonsVisibility,
  mapObjects,
  objectVisibility,
  buildings,
  elevationData,
  apartaments,
}) => {
  /****************************************
   * Build the table-based HTML for owners
   ****************************************/
  //   <tr>
  //   <td style="padding: 8px; background-color: #f9f9f9; color: #555;">Krijuar me daten</td>
  //   <td style="padding: 8px; color: #333;">${format(new Date(), info.createdAt)}</td>
  // </tr>
  const buildApartmentOwnerContent = (data) => {
    if (!data) {
      return `
        <div style="padding: 20px; font-family: 'Inter', sans-serif;">
          <div style="margin-top: 10px; color: #b94a48; background: #f2dede; padding: 10px; border-radius: 6px; font-size: 14px;">
            ❌ Të dhënat nuk janë të disponueshme.
          </div>
        </div>
      `;
    }

    const buildTableSection = (title, entries) => `
      <div style="margin-bottom: 20px;">
        <h5 style="padding: 8px 6px; border: none; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 500; transition: 0.2s; box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 4px; background-color: rgb(62, 118, 57); color: rgb(255, 255, 255);">
          ${title}
        </h5>
        <table style="width: 100%; border-collapse: collapse; font-size: 14px; color: #1a2e1a; margin-top: 10px; border: 1px solid #d4e8d4; border-radius: 6px; overflow: hidden;">
          <tbody>
            ${entries}
          </tbody>
        </table>
      </div>
    `;

    const buildRows = (obj, ignore = []) =>
      obj
        ? Object.entries(obj)
            .filter(([key]) => !ignore.includes(key))
            .map(
              ([key, value]) => `
              <tr>
                <td style="padding: 12px; background: #f0f7f0; color: #2d4a2d; font-weight: 500; border-bottom: 1px solid #d4e8d4;">
                  ${key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())}
                </td>
                <td style="padding: 12px; color: #1a2e1a; border-bottom: 1px solid #d4e8d4;">
                  ${value || "-"}
                </td>
              </tr>`
            )
            .join("")
        : `<tr><td colspan='2' style='padding: 12px; color: #b94a48;'>❌ Nuk ka të dhëna</td></tr>`;

    return `
      <div style="font-family: 'Inter', sans-serif; background-color: #f8fdf8; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);">
        
      ${
        data.building_part.detajetEApartamentit
          ? `<div style="margin-bottom: 12px; text-align: left;">
              <a 
                href="${process.env.REACT_APP_UPLOADS}/${data.building_part.detajetEApartamentit}" 
                target="_blank"
                style="
                  display: inline-flex;
                  align-items: center;
                  gap: 8px;
                  padding: 10px 16px;
                  background-color: #e6f0e6;
                  border: 1px solid #bcd6bc;
                  border-radius: 8px;
                  color: #3e7639;
                  text-decoration: none;
                  font-weight: 600;
                  font-size: 14px;
                  transition: all 0.2s ease;
                      text-align: center;
                      width:100%;
                          justify-content: center;
                "
                onmouseover="this.style.backgroundColor='#cde3cc'; this.style.boxShadow='0 3px 8px rgba(0,0,0,0.1)'"
                onmouseout="this.style.backgroundColor='#e6f0e6'; this.style.boxShadow='none'"
              >
                <span style="font-size: 18px;">📄</span> Shiko planin e apartamentit
              </a>
            </div>`
          : ""
      }
      
  
      ${buildTableSection(
        "🏢 Pjesë e Ndërtesës",
        buildRows(data.building_part, ["aptId", "detajetEApartamentit"])
      )}
      ${buildTableSection("🏡 Pronari / Poseduesi", buildRows(data.owner))}
      ${buildTableSection(
        "📍 Adresa e Njësisë Kadastrale",
        buildRows(data.cadastral_unit, ["aptId"])
      )}
      </div>
    `;
  };

  const getPolygonHierarchyRows = (polygon) => {
    let rows = "";

    while (polygon) {
      rows += `
        <tr>
          <td style="padding: 8px; background-color: #f9f9f9; color: #555;">
            ${polygon.listType?.name || "-"}
          </td>
          <td style="padding: 8px; color: #333;">
            ${polygon.name || "-"}
          </td>
          
        </tr>
         <tr>
         ${
           polygon.listType.listPostalCode?.postal_code_id
             ? `
          <td style="padding: 8px; background-color: #f9f9f9; color: #555;">
            Kodi Postar
          </td>
          <td style="padding: 8px; color: #333;">
            ${polygon.listType.listPostalCode?.postal_code_id || "-"}
          </td>`
             : ""
         }
           </tr>
      `;

      polygon = polygon.parent; // Move to the parent polygon
    }

    return rows;
  };

  const buildObjectPopupContent = (obj, additionalData) => {
    if (
      !additionalData ||
      !additionalData?.mapObject?.threed_obj_general_info
    ) {
      return `
        <div style="font-family: Arial, sans-serif;">
          <h6 style="background-color: rgb(84, 78, 78); color: #fff; text-align: center; padding: 10px;">
            Basic Information
          </h6>
          <div>ID: ${obj.id}</div>
          <div>Latitude: ${obj.latitude}</div>
          <div>Longitude: ${obj.longitude}</div>
        </div>
      `;
    }

    const info = additionalData?.mapObject?.threed_obj_general_info || {};
    const polygonRows = getPolygonHierarchyRows(info.polygon);
    const threedValues = additionalData?.mapObject?.threed_values || [];

    // If no threed_values, return a fallback
    if (!threedValues || threedValues.length === 0) {
      const container = document.createElement("div");
      container.style.fontFamily = "'Inter', sans-serif";
      container.style.textAlign = "center";
      container.innerHTML = `
        <div style="color: #b94a48; background: #f2dede; padding: 10px; border-radius: 6px; font-size: 14px;">
          ⚠️ No data available for this object
        </div>`;
      return container;
    }

    // Group threed_values by tab_id
    const tabData = {};
    (threedValues || []).forEach((v) => {
      const tabId = v.threed_key?.tab_id || "defaultTab";
      if (!tabData[tabId]) tabData[tabId] = [];
      tabData[tabId].push(v);
    });

    const hasDefaultTabData = threedValues.some((v) => {
      const isDefault = !v.threed_key?.tab_id;
      const hasValidValue =
        (v?.list_id &&
          v.threed_key?.list_type?.lists?.some((l) => l.id === v.list_id)) ||
        (v?.name && v.name.trim()) ||
        v?.date;
      return isDefault && hasValidValue;
    });

    // Create tabs array, only including defaultTab if there are values without tab_id
    const tabs = Object.keys(tabData)
      .filter((id) => id !== "defaultTab" || hasDefaultTabData) // Only include defaultTab if it has data
      .map((id) => {
        const key = tabData[id][0]?.threed_key;
        return {
          id,
          name:
            key?.list?.name ||
            (id === "defaultTab" ? "Të dhënat gjenerale" : `Tab ${id}`),
          order: key?.order ?? 9999,
        };
      })
      .sort((a, b) => a.order - b.order);

    const container = document.createElement("div");
    container.style.fontFamily = "'Inter', sans-serif";
    container.style.textAlign = "center";

    const nav = document.createElement("div");
    nav.style.display = "flex";
    nav.style.justifyContent = "center";
    nav.style.gap = "10px";
    nav.style.paddingBottom = "8px";
    container.appendChild(nav);

    const content = document.createElement("div");
    content.style.textAlign = "left";
    container.appendChild(content);

    const renderTabContent = (tabId) => {
      if (tabId === "locationTab") {
        content.innerHTML = `
          <table style="width: 100%; border-collapse: collapse; font-size: 14px; color: #1a2e1a; margin: 0 auto; max-width: 400px; border: 1px solid #d4e8d4;">
            <tbody>
              ${
                polygonRows ||
                `<tr><td colspan="2">❌ Nuk ka të dhëna</td></tr>`
              }
            </tbody>
          </table>`;
        return;
      }

      const filteredValues = (tabData[tabId] || []).filter((val) => {
        const hasListValue =
          val?.list_id &&
          val.threed_key?.list_type?.lists?.some((l) => l.id === val.list_id);
        const hasName =
          val?.name && typeof val.name === "string" && val.name.trim();
        const hasDate = val?.date;
        return hasListValue || hasName || hasDate;
      });

      if (filteredValues.length === 0) {
        content.innerHTML = `
          <div style="color: #b94a48; background: #f2dede; padding: 10px; border-radius: 6px; font-size: 14px;">
            ⚠️ Asnjë vlerë e disponueshme
          </div>`;
        return;
      }

      const rowsHtml = filteredValues.map((val) => {
        let displayValue = "-";

        if (val?.list_id && val.threed_key?.list_type?.lists) {
          const listItem = val.threed_key.list_type.lists.find(
            (l) => l.id === val.list_id
          );
          displayValue = listItem?.name || "-";
        } else if (val?.date) {
          const dateObj = new Date(val.date);
          if (!isNaN(dateObj)) {
            displayValue = dateObj.toLocaleDateString("sq-AL");
          }
        } else if (val?.name?.trim()) {
          displayValue = val.name;
        }

        return `
          <tr style="transition: background-color 0.3s;">
            <td style="padding: 12px; background: #f0f7f0; color: #2d4a2d; font-weight: 500; border-bottom: 1px solid #d4e8d4;">
              ${val.threed_key?.name || "Pa emër"}
            </td>
            <td style="padding: 12px; color: #1a2e1a; border-bottom: 1px solid #d4e8d4;">
              ${displayValue}
            </td>
          </tr>`;
      });

      content.innerHTML = `
        <table style="width: 100%; border-collapse: collapse; font-size: 14px; color: #1a2e1a; margin: 0 auto; max-width: 400px; border: 1px solid #d4e8d4;">
          <tbody>
            <tr>
              <td style="padding: 12px; background: #d9f2d9; color: #2d4a2d; font-weight: 500; border-bottom: 1px solid #d4e8d4;">
                ID e objektit
              </td>
              <td style="padding: 12px; color: #1a2e1a; border-bottom: 1px solid #d4e8d4;">
                ${obj.id}
              </td>
            </tr>
            ${rowsHtml.join("")}
          </tbody>
        </table>`;
    };

    // Add the location tab
    const allTabs = [
      ...tabs,
      { id: "locationTab", name: "Të dhënat e lokacionit", order: 9999 },
    ];

    // If there are no tabs except locationTab, just render the location tab content
    if (allTabs.length === 1 && allTabs[0].id === "locationTab") {
      renderTabContent("locationTab");
      return container;
    }

    // Render tabs
    allTabs.forEach((tab, idx) => {
      const btn = document.createElement("button");
      btn.textContent = tab.name;
      btn.style.padding = "8px 6px";
      btn.style.border = "none";
      btn.style.borderRadius = "6px";
      btn.style.cursor = "pointer";
      btn.style.fontSize = "14px";
      btn.style.fontWeight = "500";
      btn.style.transition = "all 0.2s ease";
      btn.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";

      if (idx === 0) {
        btn.style.backgroundColor = "rgb(62, 118, 57)";
        btn.style.color = "#fff";
        renderTabContent(tab.id);
      } else {
        btn.style.backgroundColor = "#e6f0e6";
        btn.style.color = "#2d4a2d";
      }

      btn.addEventListener("mouseover", () => {
        if (btn.style.backgroundColor !== "rgb(62, 118, 57)") {
          btn.style.backgroundColor = "#c7e4c4";
        }
      });

      btn.addEventListener("mouseout", () => {
        if (btn.style.backgroundColor !== "rgb(62, 118, 57)") {
          btn.style.backgroundColor = "#e6f0e6";
        }
      });

      btn.addEventListener("click", () => {
        nav.querySelectorAll("button").forEach((b) => {
          b.style.backgroundColor = "#e6f0e6";
          b.style.color = "#2d4a2d";
        });
        btn.style.backgroundColor = "rgb(62, 118, 57)";
        btn.style.color = "#fff";
        renderTabContent(tab.id);
      });

      nav.appendChild(btn);
    });

    return container;
  };

  const buildPolygonPopupContent = (polygonData) => {
    // 1) Prepare data groups with fallback for missing tab_id
    const tabData = {};
    (polygonData.polygon_values || []).forEach((v) => {
      const tabId = v.polygon_key?.tab_id || "defaultTab"; // Default to 'defaultTab' if tab_id is missing
      if (!tabData[tabId]) tabData[tabId] = [];
      tabData[tabId].push(v);
    });
    const tabs = Object.keys(tabData)
      .map((id) => {
        const key = tabData[id][0]?.polygon_key;
        return {
          id,
          name:
            key?.list?.name || `Tab ${id === "defaultTab" ? "Default" : id}`,
          order: key?.order ?? 9999,
        };
      })
      .sort((a, b) => a.order - b.order);

    // 2) Create a container element
    const container = document.createElement("div");
    container.style.fontFamily =
      "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";
    container.style.textAlign = "center";

    // 3) Build the tabs navigation bar
    const nav = document.createElement("div");
    nav.style.display = "flex";
    nav.style.justifyContent = "center";
    nav.style.gap = "10px";
    nav.style.paddingBottom = "8px";
    container.appendChild(nav);

    // 4) Build the content area
    const content = document.createElement("div");
    content.style.textAlign = "left";
    container.appendChild(content);

    // 5) Helper to render the table for a given tabId
    function renderTab(tabId) {
      const rowsHtml = tabData[tabId]
        .map((v) => {
          const display = v.date
            ? format(new Date(v.date), "dd/MM/yyyy")
            : v.list?.name || v.name || "-";
          return `
          <tr style="transition: background-color 0.3s;">
            <td style="padding: 12px; background: #f0f7f0; color: #2d4a2d; font-weight: 500; border-bottom: 1px solid #d4e8d4;">
              ${v.polygon_key.name}
            </td>
            <td style="padding: 12px; color: #1a2e1a; border-bottom: 1px solid #d4e8d4;">
              ${display}
            </td>
          </tr>`;
        })
        .join("");

      content.innerHTML = `
      <table style="width: 100%; border-collapse: collapse; font-size: 14px; color: #1a2e1a; margin: 0 auto; max-width: 400 400px; border: 1px solid #d4e8d4;">
        <tbody>
          ${
            rowsHtml ||
            `<tr><td colspan="2" style="padding: 16px; text-align: center; color: #4a704a;">⚠️ No values available</td></tr>`
          }
        </tbody>
      </table>`;
    }

    // 6) Create buttons and wire up click handlers
    tabs.forEach((tab, idx) => {
      const btn = document.createElement("button");
      btn.textContent = tab.name;
      btn.style.padding = "8px 16px";
      btn.style.border = "none";
      btn.style.borderRadius = "6px";
      btn.style.cursor = "pointer";
      btn.style.fontSize = "14px";
      btn.style.fontWeight = "500";
      btn.style.transition = "all 0.2s ease";
      btn.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";

      // Initial active style
      if (idx === 0) {
        btn.style.backgroundColor = "rgb(62, 118, 57)";
        btn.style.color = "#fff";
        renderTab(tab.id);
      } else {
        btn.style.backgroundColor = "#e6f0e6";
        btn.style.color = "#2d4a2d";
      }

      btn.addEventListener("mouseover", () => {
        if (btn.style.backgroundColor !== "rgb(62, 118, 57)") {
          btn.style.backgroundColor = "#c7e4c4";
        }
      });
      btn.addEventListener("mouseout", () => {
        if (btn.style.backgroundColor !== "rgb(62, 118, 57)") {
          btn.style.backgroundColor = "#e6f0e6";
        }
      });
      btn.addEventListener("click", () => {
        nav.querySelectorAll("button").forEach((b) => {
          b.style.backgroundColor = "#e6f0e6";
          b.style.color = "#2d4a2d";
        });
        btn.style.backgroundColor = "rgb(62, 118, 57)";
        btn.style.color = "#fff";
        renderTab(tab.id);
      });
      nav.appendChild(btn);
    });

    return container;
  };
  /****************************************
   * Memoized Layers
   ****************************************/
  /****************************************
   * 1) Polygons Layer
   ****************************************/
  const polygonsLayer = useMemo(() => {
    const layer = new GraphicsLayer();
    if (!polygonsVisibility) return layer;

    // Build a lookup map for parent-child depth
    const polygonMap = {};
    (polygons || []).forEach((p) => {
      polygonMap[p.id] = p;
    });

    // Recursively climb up parent_id to find depth
    function getPolygonDepth(poly) {
      let depth = 0;
      let current = poly;
      while (current?.parent_id && polygonMap[current.parent_id]) {
        depth += 0.5;
        current = polygonMap[current.parent_id];
      }
      return depth;
    }

    // Sort polygons by ascending depth => parents first, children after
    const sortedPolygons = [...(polygons || [])].sort((a, b) => {
      return getPolygonDepth(a) - getPolygonDepth(b);
    });

    sortedPolygons.forEach((poly, index) => {
      const rings = poly.polygon_points.map((pt) => [
        pt?.longitude,
        pt?.latitude,
        pt?.altitude,
        // elevationData ? pt.altitude : 0
      ]);

      // Create geometry
      const polygon = new Polygon({
        rings: [rings],
        spatialReference: { wkid: 4326 },
      });
      const depth = getPolygonDepth(poly);
      // Pick your color
      const polygonHex = poly?.list?.listProperties?.color || "#f5602a";

      // Build 3D symbol
      const symbol = new PolygonSymbol3D({
        symbolLayers: [
          // Slight fill layer (can be made transparent if needed)
          new FillSymbol3DLayer({
            material: {
              // Example: partial transparency for all polygons, if desired:
              // color: hexToRgba(polygonHex, 0.8)
            },
            outline: {
              color: "rgba(253, 105, 105, 0.5)",
              size: 1,
            },
          }),
          // Extrude a bit so polygons have thickness
          new ExtrudeSymbol3DLayer({
            material: { color: polygonHex },
            size: depth == 0 ? 0.01 : depth * 0.02, // or 0.1, as you prefer
          }),
        ],
        // The key to stacking visually above the parent
        // elevationInfo: {
        //   mode: "relative-to-ground",
        //   offset: offsetValue
        // }
      });
      const attributes = {
        name: poly.name,
        objectDetail: "Polygon",
        id: poly.id,
        listName: poly?.list?.name || "Unknown",
      };
      const graphic = new Graphic({
        geometry: polygon,
        symbol,
        attributes,

        popupTemplate: {
          title: `Poligoni: ${poly.name} - Tipi: ${poly?.list?.name}`,
          content: async (feature) => {
            const loadingDiv = document.createElement("div");
            loadingDiv.style.textAlign = "center";
            loadingDiv.style.color = "#4a704a";
            loadingDiv.innerHTML = "⏳ Loading...";
            try {
              const response = await axios.get(
                `/polygons/${feature.graphic.attributes.id}`
              );
              const data = response.data.data;
              return data && data.polygon_values
                ? buildPolygonPopupContent(data)
                : "<div style='text-align: center; color: #6b7280;'>⚠️ No data available</div>";
            } catch (error) {
              console.error("Error fetching polygon data:", error);
              return "<div style='text-align: center; color: #dc2626;'>❌ Failed to load data. Please try again later.</div>";
            }
          },
        },
      });

      layer.add(graphic);
    });

    return layer;
  }, [polygons, polygonsVisibility, elevationData]);

  {
    console.log("mapObjects", mapObjects);
  }
  // 2) 3D Objects Layer
  const objectsLayer = useMemo(() => {
    const layer = new GraphicsLayer();
    if (!objectVisibility) return layer;

    (mapObjects || []).forEach((obj) => {
      const objectPoint = new Point({
        longitude: obj.longitude,
        latitude: obj.latitude,
        // z: obj?.threed_obj_general_info?.altitude,
        z: obj.altitude,
        spatialReference: { wkid: 4326 },
      });

      const objectSymbol = {
        type: "point-3d",
        symbolLayers: [
          new ObjectSymbol3DLayer({
            resource: {
              href: process.env.REACT_APP_UPLOADS + "/" + obj.object_href,
            },
            height: obj?.threed_obj_general_info?.height || obj?.height,
            tilt: obj.tilt,
            heading: obj.heading,
          }),
        ],
      };

      const objectGraphic = new Graphic({
        geometry: objectPoint,
        symbol: objectSymbol,
        attributes: { ...obj, objectDetail: "Object3D" },
        popupTemplate: {
          title: `${obj.name}`,
          content: async () => {
            let additionalData = null;
            try {
              const response = await axios.get(`/map-objects/${obj?.id}`);
              additionalData = response?.data?.data;
            } catch (error) {
              console.error("Error fetching additional data:", error);
            }
            return buildObjectPopupContent(obj, additionalData);
          },
        },
      });

      layer.add(objectGraphic);
    });

    return layer;
  }, [mapObjects, objectVisibility, elevationData]);

  // 3) Apartments Layer
  const apartmentsLayer = useMemo(() => {
    // Give it a title so we can easily look it up:
    const layer = new GraphicsLayer({ title: "Apartments" });

    (apartaments || []).forEach((apt) => {
      // (Same checks: if invalid coords, skip, etc.)

      const apartmentPolygon = new Polygon({
        rings: apt.coords.map((coord) => [
          coord[0],
          coord[1],
          apt.floorAltitude,
        ]),
        spatialReference: { wkid: 4326 },
      });

      const apartmentSymbol = new PolygonSymbol3D({
        symbolLayers: [
          new ExtrudeSymbol3DLayer({
            material: { color: apt.color || "orange" },
            size: Math.max(apt.floorHeight || 2, 2),
          }),
        ],
      });

      const apartmentGraphic = new Graphic({
        geometry: apartmentPolygon,
        symbol: apartmentSymbol,
        attributes: {
          // Store a unique apartmentId so we know which apt to fetch
          apartmentId: apt.apartmentId,
          floor: apt.floor,
          name: apt.name,
          area: `${apt.coords.length * 50} m²`,
          aptColor: apt.color,
          objectDetail: "ApartmentDetail",
        },
        // ----- POPUP TEMPLATE: MAKE IT ASYNC -----
        popupTemplate: {
          title: `Apartment: ${apt.name}`,
          content: async () => {
            let details = null;
            try {
              // 1) Fetch apt details from your API
              const response = await axios.get(
                `/apartment-info/apartment/${apt.apartmentId}`
              );
              details = response?.data?.data;
            } catch (error) {
              console.error("Failed to fetch apartment info:", error);
            }

            // 2) If no data, show something simple
            if (!details) {
              return `<p style="color: red;">No details available for this apartment.</p>`;
            }

            // 3) Build the fancy HTML from your existing function
            //    (Assuming you have buildApartmentOwnerContent imported or in the same file)
            return buildApartmentOwnerContent(details);
          },
        },
      });

      layer.add(apartmentGraphic);
    });

    return layer;
  }, [apartaments, elevationData]);

  // 4) Buildings Layer (Extruded Floors)
  const buildingGraphicsLayer = useMemo(() => {
    const layer = new GraphicsLayer();

    // A helper function to attach the click event listener for apartment items.
    // (This listener is attached once per popup content generation.)
    function attachApartmentClickListener() {
      document.addEventListener("click", async (ev) => {
        if (!ev.target.classList.contains("apartment-item")) return;
        ev.preventDefault();
        ev.stopPropagation();

        const aptDataTest = ev.target.querySelector("span");
        const decodedData = decodeURIComponent(
          aptDataTest?.classList[0] || "{}"
        );
        const aptData = JSON.parse(decodedData);

        if (!aptData?.apartmentId) {
          console.error("Apartment ID is missing!");
          return;
        }
        if (ev.target.dataset.fetching === "true") {
          console.log(
            `Already fetching data for Apartment ID: ${aptData.apartmentId}`
          );
          return;
        }
        ev.target.dataset.fetching = "true";
        try {
          const { data } = await axios.get(
            `apartment-info/apartment/${aptData.apartmentId}`
          );
          const popupContent = buildApartmentOwnerContent(data?.data);
          if (view) {
            view.popup.open({
              title: aptData.name
                ? `Apartment: ${aptData.name}`
                : "Apartment Details",
              content: popupContent,
              location: {
                longitude: aptData?.coords?.[0]?.[0] || 0,
                latitude: aptData?.coords?.[0]?.[1] || 0,
              },
            });
          }
          const apartmentsLayer = view.map.findLayerByTitle("Apartments");
          if (apartmentsLayer) {
            const match = apartmentsLayer.graphics.find(
              (g) => g.attributes.apartmentId === aptData.apartmentId
            );
            if (match) {
              view.whenLayerView(apartmentsLayer).then((layerView) => {
                if (window._highlightHandle) window._highlightHandle.remove();
                window._highlightHandle = layerView.highlight(match);
              });
            }
          }
        } catch (err) {
          console.error("Error fetching apartment data:", err);
        } finally {
          ev.target.dataset.fetching = "false";
        }
      });
    }

    // Process each building
    buildings.forEach((building) => {
      const {
        buildingName,
        convertedObjects,
        floorsHeight,
        absoluteQuotas,
        heightFloors,
        colors,
        floorDetails,
      } = building;
      const sliceHeight = 0.1;

      // For multi‑floor buildings without elevation data, maintain a running altitude.
      let currentAltitude = elevationData ? undefined : 0;

      // Loop through every floor (this single loop covers both one‑floor and multi‑floor cases)
      for (let i = 0; i < floorsHeight; i++) {
        const detail = floorDetails[i];
        const color = colors[i % colors.length];
        const floorAltitude = elevationData ? absoluteQuotas[i] : i * 3;
        const floorHeight = (heightFloors[i] || 3) - sliceHeight;

        const floorPolygon = new Polygon({
          rings: convertedObjects.map((ring) => [
            ring[0],
            ring[1],
            floorAltitude,
          ]),
          spatialReference: { wkid: 4326 },
        });

        const floorSymbol = new PolygonSymbol3D({
          symbolLayers: [
            new ExtrudeSymbol3DLayer({
              material: {
                color: floorsHeight === 1 ? color : "rgba(196, 183, 190, 0.2)",
              },
              size: floorHeight,
            }),
          ],
        });
        // Create the floor graphic with its popup template.
        const floorGraphic = new Graphic({
          geometry: floorPolygon,
          symbol: floorSymbol,
          attributes: {
            buildingName,
            floorName: detail.name,
            floorNumber: detail.floor,
            floor: i + 1,
            objectDetail: "BuildingDetail",
            totalFloors: floorsHeight,
          },
          //   popupTemplate: {
          //     title: (feature) => {
          //       const { floorName, floorNumber } = feature.graphic.attributes;
          //       const floorIds = floorDetails.map((d) => d.id);
          //       const apartmentsOnFloor = apartaments.filter(
          //         (apt) =>
          //           floorIds.includes(apt.id) &&
          //           apt.floorName === `${floorName} ${floorNumber}` &&
          //           apt.coords &&
          //           apt.coords.length > 0 &&
          //           apt.coords.every(isValidCoord)
          //       );
          //       console.log("aptNames", apartmentsOnFloor);
          //       return `${floorName} ${floorNumber}`;
          //     },
          //     content: (feature) => {
          //       const floorNumber = feature.graphic.attributes.floorNumber;
          //       const floorBuildingName = feature.graphic.attributes.buildingName;
          //       const floorName = feature.graphic.attributes.floorName;
          //       const floorIds = floorDetails.map((d) => d.id);
          //       const apartmentsOnFloor = apartaments.filter((apt) => {
          //         if (!floorIds.includes(apt.id)) return false;
          //         if (apt.floorName !== `${floorName} ${floorNumber}`) return false;
          //         if (!apt.coords || apt.coords.length === 0) return false;
          //         if (!apt.coords.every(isValidCoord)) return false;
          //         return true;
          //       });
          //       let apartmentList = "<div>";
          //       apartmentsOnFloor.forEach((apt, index) => {
          //         apartmentList += `
          //           <a href="#">
          //             <div
          //               class="apartment-item"
          //               style="cursor: pointer; color: blue; text-decoration: underline; margin: 5px 0;"
          //             >
          //               ${index + 1}. ${apt.name} - ${apt.area || "-"} m²
          //               <span class='${encodeURIComponent(JSON.stringify(apt))}'></span>
          //             </div>
          //           </a>
          //         `;
          //       });
          //       apartmentList += "</div>";
          //       // Attach the click listener for apartment items.
          //       attachApartmentClickListener();
          //       return `
          //         <b>Building:</b> ${floorBuildingName} <br />
          //         ${
          //           apartmentsOnFloor.length > 0
          //             ? `<b>Apartments:</b> ${apartmentList}`
          //             : `<div style="margin-top: 10px; color: #999; font-size: 14px;">
          //                  No apartments available.
          //                </div>`
          //         }
          //       `;
          //     },
          //   },
        });

        layer.add(floorGraphic);

        // For multi‑floor buildings, update the running altitude and add a slice graphic if needed.
        if (floorsHeight > 1) {
          if (!elevationData) {
            currentAltitude += floorHeight;
          }
          if (i < floorsHeight - 1) {
            const sliceAltitude =
              (elevationData ? absoluteQuotas[i] : currentAltitude) +
              floorHeight;
            const slicePolygon = new Polygon({
              rings: convertedObjects.map((ring) => [
                ring[0],
                ring[1],
                elevationData ? sliceAltitude : currentAltitude,
              ]),
              spatialReference: { wkid: 4326 },
            });
            const sliceSymbol = new PolygonSymbol3D({
              symbolLayers: [
                new ExtrudeSymbol3DLayer({
                  material: { color: "#FFFFFF" },
                  size: sliceHeight,
                }),
              ],
            });
            const sliceGraphic = new Graphic({
              geometry: slicePolygon,
              symbol: sliceSymbol,
              attributes: {
                buildingName,
                slice: i + 1,
              },
            });
            // layer.add(sliceGraphic);
          }
          layer.add(floorGraphic);
        }
      } // end for-each floor
    }); // end for-each building

    return layer;
  }, [buildings, apartaments, elevationData]);

  /****************************************
   * useEffect: Initialize / Update Map
   ****************************************/
  useEffect(() => {
    if (!view) {
      // Create the ArcGIS map & SceneView once
      const map = new Map({
        basemap: "topo-vector",
        ground: elevationData ? "world-elevation" : null,
      });

      const sceneView = new SceneView({
        container: "viewDiv",
        qualityProfile: "high",
        map: map,
        camera: {
          position: [21.146644, 42.644623, 1100],
          tilt: 60,
        },
        environment: {
          lighting: {
            directShadowsEnabled: true,
            ambientOcclusionEnabled: false,
            date: new Date("2024-07-20T16:00:00"),
          },
        },
      });

      setView(sceneView);
      return;
    }

    // If we already have a view, re-add memoized layers
    view.map.removeAll();

    view.map.add(polygonsLayer);
    view.map.add(objectsLayer);
    view.map.add(apartmentsLayer);
    view.map.add(buildingGraphicsLayer);
  }, [
    view,
    setView,
    polygonsLayer,
    objectsLayer,
    apartmentsLayer,
    buildingGraphicsLayer,
    elevationData,
  ]);

  return <div id="viewDiv" style={{ height: "100vh", width: "100%" }}></div>;
};

export default MapView;
